import {
  type TypedUseSelectorHook,
  useSelector as useSelectorWithoutTypes,
} from 'react-redux';
import { type RootState } from '~/store';

export const useSelector: TypedUseSelectorHook<RootState> =
  useSelectorWithoutTypes;
